import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
  useContext,
} from "react";
import { AuthContext } from "../../context/AuthContext";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import {
  Box,
  Divider,
  LinearProgress,
  TextField,
  Typography,
  Chip,
} from "@mui/material";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import PulseLoader from "react-spinners/PulseLoader";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { getDataWithToken } from "../../services/GetDataService";

import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

import Checkbox from "@mui/material/Checkbox";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextEditor from "../../utils/TextEditor";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableContainer } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import Skeleton from "@mui/material/Skeleton";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import {
  abnormalCategories,
  customerTypeList,
  designationList,
  paymentStatusList,
  purchaseStatusList,
  ratingList,
  roleList,
} from "../../data";
import { handlePostData } from "../../services/PostDataService";
import BarcodeGenerate from "../../utils/BarcodeGenerate";
import { customeSelectFeild } from "../../color-palette/customDesign";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "16px 24px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#EAECF0",
  borderStyle: "dashed",
  backgroundColor: "#fff",
  // color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
  borderRadius: "12px",
};

const focusedStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#F9FAFB",
  padding: "16px 12px",
  borderRadius: "8px !important",
  border: "1px solid #EAECF0",
  cursor: "pointer",
}));

const abnormalCategoryColors = {
  Lost: { color: "#5c5c5c", bg: "#f0f0f0" },
  "Damaged by technician": { color: "#C81E1E", bg: "#FDF2F2" },
  Defect: { color: "#C8701E", bg: "#FDF9F2" },
  "Shipping damage": { color: "#1E4FC8", bg: "#F2F5FD" },
  "Supplier damage": { color: "#9F1EC8", bg: "#F7F2FD" },
  "Old software warranty": { color: "#1E82C8", bg: "#F2F9FD" },
  "iFixit warranty": { color: "#046C4E", bg: "#F3FAF7" },
};

const StockAdjustmentList = ({}) => {
  const navigate = useNavigate();
  const { login, ifixit_admin_panel, logout } = useContext(AuthContext);
  const [addDialog, setAddDialog] = useState(false);
  const [supplierList, setSupplierList] = useState([]);
  const [supplierId, setSupplierId] = useState("");
  const [abnormalCategory, setAbnormalCategory] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [branch, setBranch] = useState("");
  const [purchaseStatus, setPurchaseStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [purchaseDate, setPurchaseDate] = useState(null);
  const [shippingCharge, setShippingCharge] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [searchProductText, setsearchProductText] = useState("");
  const [productList, setProductList] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [purchaseBy, setPurchaseBy] = useState("");
  const [userList, setUserList] = useState([]);

  const [brandId, setBrandId] = useState([]);
  const [categoryId, setCategoryId] = useState([]);
  const [deviceId, setDeviceId] = useState([]);
  const [modelId, setModelId] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [modelList, setModelList] = useState([]);

  const [price, setPrice] = useState("");
  const [file, setFile] = useState(null);
  const [remarks, setRemarks] = useState("");

  const [loading2, setLoading2] = useState(false);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const pageLoading = () => {
    let content = [];
    let loadingNumber = 7;
    for (let i = 0; i < 10; i++) {
      content.push(
        <TableRow key={i}>
          {[...Array(loadingNumber).keys()].map((e, index) => (
            <TableCell key={index}>
              <Skeleton></Skeleton>
            </TableCell>
          ))}
        </TableRow>,
      );
    }
    return content;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getSKU(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getSKU(0, parseInt(event.target.value, 10));
  };

  const [message, setMessage] = useState("");
  const [details, setDetails] = useState("");
  const [limitDataList, setLimitDataList] = useState();
  const [limitDataLoading, setLimitDataLoading] = useState(false);
  const [productData, setProductData] = useState({});
  const [generateSkuData, setGenerateSkuData] = useState({});
  const [skuProductName, setSkuProductName] = useState("");
  const [skuLoading, setSkuLoading] = useState(false);
  const [skuList, setSkuList] = useState([]);
  const [generateSKULoading, setGenerateSKULoading] = useState(false);
  const [stockStatus, setStockStatus] = useState("");

  const { enqueueSnackbar } = useSnackbar();

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const clearFilter = () => {
    setBrandId("");
    setCategoryId("");
    setDeviceId("");
    setModelId("");
    setAbnormalCategory("");
    setSupplierId("");
    setBranch("");
    setStockStatus("");
    setSkuList([]);
  };
  const customeTextFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    // padding: "15px 20px",

    // "& label.Mui-focused": {
    //   color: "#A0AAB4",
    // },

    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {
      // padding: "15px 24px 15px 0px",
    },
    "& .MuiOutlinedInput-root": {
      // paddingLeft: "24px",
      "& fieldset": {
        borderColor: "",
      },

      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const getBrandList = async () => {
    setLoading2(true);

    let url = `/api/v1/brand/dropdownlist`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setBrandList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };

  const getBranchList = async () => {
    setLoading2(true);

    let url = `/api/v1/branch/dropdownlist`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      let newBranchWithLimit = allData?.data?.data?.map((item) => ({
        ...item,
        limit: "",
      }));
      console.log("newBranchWithLimit", newBranchWithLimit);

      setBranchList(newBranchWithLimit);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };

  const getCategoryList = async () => {
    setLoading2(true);

    let url = `/api/v1/category/dropdownlist`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setCategoryList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };

  const getSupplierList = async () => {
    setLoading2(true);

    let url = `/api/v1/supplier/dropdownlist`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setSupplierList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };

  const getDeviceList = async () => {
    setLoading2(true);

    let url = `/api/v1/device/dropdownlist`;
    let allData = await getDataWithToken(url);
    console.log("allData?.data?.data", allData?.data?.data);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setDeviceList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };
  const getModelList = async (id) => {
    setLoading2(true);

    let url = `/api/v1/model/device-model?deviceId=${id}`;
    // let url = `/api/v1/model/dropdownlist`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setModelList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };
  const getBranchLimit = async (product_variation_id) => {
    setLimitDataLoading(true);

    // let url = `/api/v1/model/device-model?deviceId=${id}`;
    let url = `/api/v1/stockCounterAndLimit/branch-limit?product_variation_id=${product_variation_id}`;
    let data = { product_variation_id };
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }

    if (allData.status >= 200 && allData.status < 300) {
      setLimitDataLoading(false);
      // setModelList(allData?.data?.data);

      let newBranchList = branchList?.map((item) => {
        let newData = allData?.data?.data?.find(
          (el) => el.branch_id === item?._id,
        );
        return { ...item, limit: newData?.stock_limit || 0 }; // Defaults to 0 if stock_limit is undefined
      });

      setBranchList(newBranchList);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLimitDataLoading(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
  };

  const getProducts = async (searchText, bId, dId, mId, catId) => {
    setSearchLoading(true);
    let url;
    let newSearchProductText = searchProductText;
    let newBrandId = brandId;
    let newDeviceId = deviceId;
    let newModelId = modelId;
    let newCategoryId = categoryId;
    if (searchText) {
      newSearchProductText = searchText;
    }
    if (bId) {
      newBrandId = bId;
    }
    if (dId) {
      newDeviceId = dId;
    }
    if (mId) {
      newModelId = mId;
    }
    if (catId) {
      newCategoryId = catId;
    }

    url = `/api/v1/product?name=${newSearchProductText.trim()}&category_id=${newCategoryId}&brand_id=${newBrandId}&device_id=${newDeviceId}&model_id=${newModelId}&limit=1000`;

    let allData = await getDataWithToken(url);
    console.log("(allData?.data?.data products", allData?.data?.data);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setProductList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setSearchLoading(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setSearchLoading(false);
  };

  const getSKU = async (pageNO, limit) => {
    setSkuLoading(true);

    let newPageNO = page;
    if (pageNO >= 0) {
      newPageNO = pageNO;
    }
    let newLimit = rowsPerPage;
    if (limit) {
      newLimit = limit;
    }

    let url;
    let newSearchProductText = searchProductText;
    let newBrandId = brandId;
    let newDeviceId = deviceId;
    let newModelId = modelId;
    let newCategoryId = categoryId;
    let newBranch = branch;
    let newStockStatus = stockStatus;
    let newAbnormalCategory = abnormalCategory;
    let newSupplierId = supplierId;

    if (brandId) {
      newBrandId = brandId;
    }
    if (deviceId) {
      newDeviceId = deviceId;
    }
    if (modelId) {
      newModelId = modelId;
    }
    if (categoryId) {
      newCategoryId = categoryId;
    }
    if (supplierId) {
      newSupplierId = supplierId;
    }
    if (branch) {
      newBranch = branch;
    }
    if (stockStatus) {
      newStockStatus = stockStatus;
    }
    if (abnormalCategory) {
      newAbnormalCategory = abnormalCategory;
    }
    setSkuList([]);

    url = `/api/v1/stock?sku_number=${encodeURIComponent(
      "",
    )}&stock_status=${newStockStatus}&branch_id=${newBranch}&category_id=${newCategoryId}&supplier_id=${newSupplierId}&abnormal_category=${newAbnormalCategory}&brand_id=${newBrandId}&device_id=${newDeviceId}&model_id=${newModelId}&limit=${newLimit}&page=${newPageNO + 1}`;
    // let url = `/api/v1/stock/stock-skus-details?sku_number=${encodeURIComponent(
    //   ""
    // )}&stock_status=${encodeURIComponent("")}&product_id=${encodeURIComponent(
    //   item.product_id
    // )}&product_variation_id=${encodeURIComponent(
    //   item.product_variation_id
    // )}&branch_id=${encodeURIComponent(
    //   tableDataList[0]?.branch_id
    // )}&purchase_id=${encodeURIComponent(
    //   item.purchase_id
    // )}&purchase_product_id=${encodeURIComponent(item._id)}`;
    let allData = await getDataWithToken(url);
    console.log("allData?.data?.data", allData?.data?.data);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setSkuList(allData?.data?.data);
      setTotalData(allData?.data?.totalData);
      setGenerateSkuData({});
      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setSkuLoading(false);
      setGenerateSkuData({});
      setGenerateSKULoading(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setSkuLoading(false);
  };
  const handleSelectedProduct = (item, product_data) => {
    console.log("item", item);
    setProductData(product_data);
    setDetails(item);
    getBranchLimit(item?._id);
    setAddDialog(true);

    // if (selectedProducts.some((res) => res._id === item._id)) {
    //   setSelectedProducts(
    //     selectedProducts.filter((res) => res._id !== item._id)
    //   );
    // } else {
    //   setSelectedProducts([
    //     ...selectedProducts,
    //     {
    //       ...item,
    //       product_id: item.product_id,
    //       product_variation_id: item._id,
    //       purchase_product_status: "",
    //       quantity: "",
    //       unit_price: "",
    //     },
    //   ]);
    // }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    // getDropdownList();
    getCategoryList();
    getBrandList();
    getDeviceList();
    // getModelList();

    getBranchList();
    getSupplierList();
  }, []);
  return (
    <>
      <Box container sx={{ padding: "24px 0" }}>
        <Typography
          variant="h6"
          gutterBottom
          component="div"
          sx={{ color: "#0F1624", fontWeight: 600 }}
        >
          Stock Adjustment List
        </Typography>
      </Box>

      <div
        style={{
          background: "#fff",
          border: "1px solid #EAECF1",
          borderRadius: "12px",
          overflow: "hidden",
          padding: "16px 0",
          boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
        }}
      >
        <Grid
          container
          justifyContent="right"
          spacing={1}
          sx={{ px: 1.5, mb: 1.75 }}
        >
          {/* <Grid size={4}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Search Product *
            </Typography>
            <TextField
              size="small"
              fullWidth
              id="searchProductText"
              placeholder="Search Product"
              variant="outlined"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                          stroke="#85888E"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </InputAdornment>
                  ),
                },
              }}
              sx={{ ...customeTextFeild }}
              value={searchProductText}
              onChange={(e) => {
                setsearchProductText(e.target.value);
                getProducts(e.target.value);
              }}
            />
          </Grid> */}

          <Grid size={3}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Branch
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {branch === "" && (
                <InputLabel
                  id="branch-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Branch
                </InputLabel>
              )}
              <Select
                labelId="branch-select-label"
                id="branch"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250,
                    },
                  },
                }}
                value={branch}
                onChange={(e) => {
                  setBranch(e.target.value);
                  // getProducts(null, e.target.value);
                }}
              >
                {branchList?.map((item) => (
                  <MenuItem key={item?._id} value={item?._id}>
                    {item?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={3}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Stock Status
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {stockStatus === "" && (
                <InputLabel
                  id="stock-status-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Stock Status
                </InputLabel>
              )}
              <Select
                labelId="stock-status-select-label"
                id="stockStatus"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250,
                    },
                  },
                }}
                value={stockStatus}
                onChange={(e) => {
                  setStockStatus(e.target.value);
                }}
              >
                {["Attached", "Returned", "Available", "Abnormal"].map(
                  (item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ),
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={3}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Abnormal Category
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {abnormalCategory?.length < 1 && (
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Abnormal Category
                </InputLabel>
              )}
              <Select
                labelId="demo-simple-select-label"
                id="supplierId"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250, // Set the max height here
                    },
                  },
                }}
                value={abnormalCategory}
                // onChange={(e) => setCategoryId(e.target.value)}

                onChange={(e) => {
                  setAbnormalCategory(e.target.value);
                  // getProducts(null, null, null, null, e.target.value);
                }}
              >
                {abnormalCategories
                  ?.filter((obj) => obj.name !== "Primary")
                  ?.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={3}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Brand
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {brandId?.length < 1 && (
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Brand
                </InputLabel>
              )}
              <Select
                labelId="demo-simple-select-label"
                id="brandId"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250, // Set the max height here
                    },
                  },
                }}
                value={brandId}
                // onChange={(e) => setBrandId(e.target.value)}

                onChange={(e) => {
                  setBrandId(e.target.value);
                  // getProducts(null, e.target.value);
                }}
              >
                {brandList
                  ?.filter((obj) => obj.name !== "Primary")
                  ?.map((item) => (
                    <MenuItem key={item?._id} value={item?._id}>
                      {item?.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={3}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Device
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {deviceId?.length < 1 && (
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Device
                </InputLabel>
              )}
              <Select
                labelId="demo-simple-select-label"
                id="deviceId"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250, // Set the max height here
                    },
                  },
                }}
                value={deviceId}
                // onChange={(e) => setBrandId(e.target.value)}

                onChange={(e) => {
                  setDeviceId(e.target.value);
                  getModelList(e.target.value);
                  // getProducts(null, null, e.target.value);
                }}
              >
                {deviceList
                  .filter((item) => !item.name.toLowerCase().includes("series"))
                  ?.map((item) => (
                    <MenuItem key={item?._id} value={item?._id}>
                      {item?.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={3}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Model
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {modelId?.length < 1 && (
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Model
                </InputLabel>
              )}
              <Select
                labelId="demo-simple-select-label"
                id="modelId"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250, // Set the max height here
                    },
                  },
                }}
                value={modelId}
                // onChange={(e) => setCategoryId(e.target.value)}

                onChange={(e) => {
                  setModelId(e.target.value);
                  // getProducts(null, null, null, e.target.value);
                }}
              >
                {modelList
                  ?.filter((obj) => obj.name !== "Primary")
                  ?.map((item) => (
                    <MenuItem key={item?._id} value={item?._id}>
                      {item?.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={3}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Category
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {categoryId?.length < 1 && (
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Category
                </InputLabel>
              )}
              <Select
                labelId="demo-simple-select-label"
                id="categoryId"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250, // Set the max height here
                    },
                  },
                }}
                value={categoryId}
                // onChange={(e) => setCategoryId(e.target.value)}

                onChange={(e) => {
                  setCategoryId(e.target.value);
                  // getProducts(null, null, null, null, e.target.value);
                }}
              >
                {categoryList
                  ?.filter((obj) => obj.name !== "Primary")
                  ?.map((item) => (
                    <MenuItem key={item?._id} value={item?._id}>
                      {item?.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={3}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Supplier
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {categoryId?.length < 1 && (
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Supplier
                </InputLabel>
              )}
              <Select
                labelId="demo-simple-select-label"
                id="supplierId"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250, // Set the max height here
                    },
                  },
                }}
                value={supplierId}
                // onChange={(e) => setCategoryId(e.target.value)}

                onChange={(e) => {
                  setSupplierId(e.target.value);
                  // getProducts(null, null, null, null, e.target.value);
                }}
              >
                {supplierList
                  ?.filter((obj) => obj.name !== "Primary")
                  ?.map((item) => (
                    <MenuItem key={item?._id} value={item?._id}>
                      {item?.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 4, lg: 2.4, xl: 2 }}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={{ lg: 1, xl: 1 }}>
                <Grid size={4}>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="info"
                    disableElevation
                    size="small"
                    sx={{ py: "4px" }}
                    onClick={clearFilter}
                  >
                    <RestartAltIcon />
                  </Button>
                </Grid>
                <Grid size={8}>
                  <Button
                    fullWidth
                    variant="contained"
                    disableElevation
                    color="info"
                    sx={{ py: "4px" }}
                    size="small"
                    disabled={skuLoading}
                    startIcon={<SearchIcon />}
                    onClick={(event) => getSKU(0)}
                  >
                    Search
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <div
          style={{
            overflowX: "auto",

            minWidth: "100%",
            width: "Calc(100vw - 385px)",
            // padding: "10px 16px 0px",
            boxSizing: "border-box",
          }}
        >
          <TableContainer sx={{ maxHeight: "Calc(100vh - 360px)" }}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead sx={{ backgroundColor: "#F9FAFB" }}>
                <TableRow>
                  <TableCell>SKU</TableCell>
                  <TableCell>Product Name</TableCell>
                  <TableCell>Supplier</TableCell>
                  <TableCell>Branch</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Abnormal Category</TableCell>
                  <TableCell>Remarks</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!skuLoading &&
                  skuList?.map((row, index) => (
                    <TableRow
                      key={row._id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell>{row.sku_number}</TableCell>
                      <TableCell>
                        {row.product_data?.[0]?.name}
                        {row.product_variation_data?.[0]?.name
                          ? ` - ${row.product_variation_data[0].name}`
                          : ""}
                      </TableCell>
                      <TableCell>{row.supplier_data?.[0]?.name}</TableCell>
                      <TableCell>{row.branch_data?.[0]?.name}</TableCell>
                      <TableCell>
                        <Chip
                          label={row.stock_status}
                          sx={{
                            color:
                              row.stock_status === "Available"
                                ? "#046C4E"
                                : row.stock_status === "Attached"
                                  ? "#1E4FC8"
                                  : row.stock_status === "Returned"
                                    ? "#C8701E"
                                    : row.stock_status === "Abnormal"
                                      ? "#C81E1E"
                                      : "#222",
                            background:
                              row.stock_status === "Available"
                                ? "#F3FAF7"
                                : row.stock_status === "Attached"
                                  ? "#F2F5FD"
                                  : row.stock_status === "Returned"
                                    ? "#FDF9F2"
                                    : row.stock_status === "Abnormal"
                                      ? "#FDF2F2"
                                      : "#f1f1f1",
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        {row.abnormal_category ? (
                          <Chip
                            label={row.abnormal_category}
                            sx={{
                              color:
                                abnormalCategoryColors[row.abnormal_category]
                                  ?.color || "#222",
                              background:
                                abnormalCategoryColors[row.abnormal_category]
                                  ?.bg || "#f1f1f1",
                            }}
                          />
                        ) : (
                          "---------"
                        )}
                      </TableCell>
                      <TableCell>{row.remarks}</TableCell>
                    </TableRow>
                  ))}
                {!skuLoading && skuList?.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No data found
                    </TableCell>
                  </TableRow>
                )}
                {skuLoading && pageLoading()}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {skuList?.length > 0 ? (
          <div>
            <TablePagination
              style={{ display: "block", border: "none" }}
              rowsPerPageOptions={[10, 25, 50, 100]}
              count={totalData || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        ) : (
          <br />
        )}
      </div>
    </>
  );
};

export default StockAdjustmentList;
